import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-consolidated-screen',
  templateUrl: './consolidated-screen.component.html',
  styleUrls: ['./consolidated-screen.component.css'],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class ConsolidatedScreenComponent implements OnInit, OnDestroy {
  public loading = false;
  screenType: number | null = null;
  selectedIngestion: any = null;
  ingestionList: any[] = [];

  constructor(private cdr: ChangeDetectorRef) { }

  ngOnInit(): void {
  }

  ngOnDestroy(): void {
  }

  onScreenTypeChange(){
  }

  onIngestionSelected(ingestion: any): void {
    this.selectedIngestion = ingestion;
    this.cdr.detectChanges();
  }

}
